import EfficiencyClassBar from './efficiency-class-bar'

export const AmuiEfficiencyClassBar = EfficiencyClassBar

export default Vue => Vue.component(EfficiencyClassBar.name, EfficiencyClassBar)
